import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
    ConfirmationWindowComponent,
    ConfirmationWindowTypes,
} from '@components/confirmation-window/confirmation-window.component';
import { SimpleDropdownOption } from '@components/simple-dropdown/simple-dropdown.component';
import { EapService } from '@service/eap.service';
import { Eap, EapLedPattern } from 'icreate/common/models/eap';
import { lastValueFrom, take } from 'rxjs';

@Component({
    selector: 'app-pattern-selection-dialog',
    templateUrl: './pattern-selection-dialog.component.html',
    styleUrl: './pattern-selection-dialog.component.css',
    standalone: false,
})
export class PatternSelectionDialog {
    @ViewChild('cancelConfirmation')
    cancelConfirmation: ConfirmationWindowComponent;

    selectedPatternId: string | null = null;
    ledPatternList: EapLedPattern[] = [];

    initialPatternId: string | null = null;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            eap: Eap;
            ledPatternList: EapLedPattern[];
        },
        private dialogRef: MatDialogRef<PatternSelectionDialog>,
        private eapService: EapService
    ) {}

    ngOnInit(): void {
        this.ledPatternList = this.data.ledPatternList ?? [];
        this.initialPatternId = this.data.eap?.eapLedPatternId ?? null;
        this.selectedPatternId = this.initialPatternId;
    }

    async save(): Promise<void> {
        if (!this.selectedPatternId) {
            return;
        }

        this.data.eap.eapLedPatternId = this.selectedPatternId;
        this.dialogRef.close(this.data.eap);
    }

    get isSaveDisabled(): boolean {
        return !this.selectedPatternId || this.selectedPatternId === this.initialPatternId;
    }

    async cancel(): Promise<boolean> {
        if (this.isSaveDisabled) {
            this.dialogRef.close();
            return true;
        }

        this.cancelConfirmation.setVisible(true);
        const confirmationOption = await lastValueFrom(this.cancelConfirmation.onOptionSelected.pipe(take(1)));
        this.cancelConfirmation.setVisible(false);

        switch (confirmationOption) {
            case ConfirmationWindowTypes.DISCARD:
                this.dialogRef.close();
                return true;

            case ConfirmationWindowTypes.GO_BACK:
                return false;

            case ConfirmationWindowTypes.SAVE:
                await this.save();
                return true;

            default:
                return false;
        }
    }

    async unassign() {
        if (!this.data.eap.eapLedPatternId) return;
        this.data.eap.eapLedPatternId = null;
        this.dialogRef.close(this.data.eap);
    }

    handleTypeChanged(event: { value: string }): void {
        this.selectedPatternId = event.value;
    }

    get patternOptions(): SimpleDropdownOption[] {
        return this.ledPatternList.map(pattern => ({
            value: pattern.id,
            string: pattern.name,
        }));
    }
}
